
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IChuongTrinhDaoTaoChiTiet } from "../../../model/respone/ctdt/IChuongTrinhDaoTaoChiTiet";
import { IChuongTrinhDaoTaoChiTietRespone } from "../../../model/respone/ctdt/IChuongTrinhDaoTaoChiTietRespone";
import { IChuongTrinhDaoTaoChiTietViewModel } from "../../../model/respone/ctdt/IChuongTrinhDaoTaoChiTietViewModel";
import { IChuongTrinhDaoTaoNhomTuChon } from "../../../model/respone/ctdt/IChuongTrinhDaoTaoNhomTuChon";
import { IChuongTrinhDaoTaoRangBuoc } from "../../../model/respone/ctdt/IChuongTrinhDaoTaoRangBuoc";
import { IChuongTrinhDaoTaoRangBuocViewModel } from "../../../model/respone/ctdt/IChuongTrinhDaoTaoRangBuocViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export interface IChuongTrinhDaoTaoChiTietActionTypeBase<T> {
    id_dt: number,
    data: T,
    // LT_VB2 routing flag — chỉ áp cho ADD_START / UPDATE_START / DELETE_START.
    // Khi mode === 'lt_vb2': saga gọi endpoint /lt-vb2 + dispatch SYNC_SIBLING_CHITIETS theo response.
    mode?: 'lt_vb2'
}
export const eChuongTrinhDaoTaoChiTietActionsObj = {
    INI_START: 0,
    LOAD_BY_CTDT_START: 0,
    LOAD_BY_CTDT_SUCCESS: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<IChuongTrinhDaoTaoChiTietRespone>,
    LOAD_BY_CTDT_ERROR: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<string>,
    CHANGE_FOCUSED_TAB: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<"mon-hoc" | "tu-chon" | "rang-buoc" | "lop">,

    UPDATE_NHOMTUCHON_CONFIG_START: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<IChuongTrinhDaoTaoNhomTuChon>,
    UPDATE_NHOMTUCHON_CONFIG_SUCCESS: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<IChuongTrinhDaoTaoNhomTuChon>,
    UPDATE_NHOMTUCHON_CONFIG_ERROR: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<string>,

    ADD_START: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<IChuongTrinhDaoTaoChiTiet[]>,
    ADD_SUCCESS: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<undefined>,
    ADD_ERROR: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<string>,

    UPDATE_START: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<IChuongTrinhDaoTaoChiTietViewModel[]>,
    UPDATE_SUCCESS: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<IChuongTrinhDaoTaoChiTietViewModel[]>,
    UPDATE_ERROR: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<string>,

    DELETE_START: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<IIdsRequest>,
    DELETE_SUCCESS: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<undefined>,
    DELETE_ERROR: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<string>,

    CHANGE_RANGBUOC_EDIT_MODAL: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<{
        isOpen: boolean,
        chuongTrinhDaoTaoRangBuoc?: IChuongTrinhDaoTaoRangBuocViewModel,
        isAddMultiple?: boolean
    }>,

    SAVE_RANGBUOC_START: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<IChuongTrinhDaoTaoRangBuoc>,
    SAVE_RANGBUOC_SUCCESS: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<undefined>,
    SAVE_RANGBUOC_ERROR: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<string>,

    DELETE_RANGBUOC_START: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<IIdsRequest>,
    DELETE_RANGBUOC_SUCCESS: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<undefined>,
    DELETE_RANGBUOC_ERROR: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<string>,

    CHANGE_ADDLOP_MODAL: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<{
        isOpen: boolean,
        lopSelectedIds: number[]
    }>,

    CHANGE_SELECTED: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<number[]>,

    // LT_VB2 cascade — saga dispatch action này sau khi nhận BatchResult,
    // 1 lần cho mỗi sibling. Reducer chỉ thay chuongTrinhDaoTaoChiTiets, giữ nguyên rangBuocs/nhomTuChons.
    SYNC_SIBLING_CHITIETS: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<IChuongTrinhDaoTaoChiTietViewModel[]>,
};
export const eChuongTrinhDaoTaoChiTietActionIds = generateActionTypeIds(
    eChuongTrinhDaoTaoChiTietActionsObj,
    "CHUONG_TRINH_DAO_TAO_CHI_TIET"
);
export type IChuongTrinhDaoTaoChiTietActionTypes = IGenericActionType<
    typeof eChuongTrinhDaoTaoChiTietActionsObj,
    "CHUONG_TRINH_DAO_TAO_CHI_TIET"
>;
